import { FC } from 'react'
import {
  OrderTotalContainer,
  OrderTotalDue,
  OrderTotalWrapper,
} from '../order.styled'
import { OrderTotalProps } from '../order.types'
import { currencyFormatted } from '@yuno/sdk-web-core/dist/utils'
import { useTranslation } from 'react-i18next'

export const OrderTotal: FC<OrderTotalProps> = ({ totalDue, currency, hasProducts }) => {
  const { t } = useTranslation()

  return (
    <OrderTotalWrapper>
      <OrderTotalContainer>
        <OrderTotalDue hasProducts={hasProducts}>
          <span>{t('Total due')}</span>
          <span>{currencyFormatted(currency, totalDue)} {currency}</span>
        </OrderTotalDue>
      </OrderTotalContainer>
    </OrderTotalWrapper>
  )
}
